import { useTranslation } from '@dreamstack/i18n'
import { ArrowLeft } from '@dreamstack/icons/src/icon-components/ArrowLeft'
import { motion } from 'framer-motion'
import type { FunctionComponent } from 'react'
import {
  AnimateIconTranslationLeft,
  useAnimateIconTranslationLeft,
} from '../../layout/AnimateIconTranslation'
import { SimpleMuiButton } from '../../layout/SimpleMuiButton'
import { BodyText, HeadingH1 } from '../../layout/Texts'
import { PropertyIndexResultAreaInnerGrid } from './PropertyFilterOverview'
import { usePropertySearchContext } from '../../next/PropertySearchContext'
import { useNewsletterForm } from '../../newsletter/useNewsletterForm'

const StyledEmailField = ({ children }: React.PropsWithChildren<{}>) => (
  <div className="col-span-full">{children}</div>
)
const StyledLegalImprintField = ({ children }: React.PropsWithChildren<{}>) => (
  <div className="col-span-full mt-px-32 lg:col-span-10">{children}</div>
)
const StyledSubmitButton = ({ children }: React.PropsWithChildren<{}>) => (
  <div className="col-span-full mt-px-32">{children}</div>
)

export const PropertyFilterOverviewNoResults: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const t = useTranslation()

  const {
    EmailField,
    LegalImprintField,
    SubmitButton,
    FormProvider,
    formProps,
    formProviderProps,
    SuccessDialog,
  } = useNewsletterForm('light')

  const { onHoverStart, controls } = useAnimateIconTranslationLeft()

  const { setPropertySearchFilterValues } = usePropertySearchContext()

  const onGoBackClick = () => {
    setPropertySearchFilterValues({ cities: [], locations: [], regions: [] })
    window?.scrollTo(0, 0)
  }
  return (
    <PropertyIndexResultAreaInnerGrid>
      <div className="col-span-full mb-[-104px] md:col-start-2 md:col-span-6 md:mb-[-176px] lg:mb-[-144px]">
        <HeadingH1>{t('accentro:formTexts.soldOut')}</HeadingH1>
        <BodyText className="font-semibold mt-px-20 lg:mt-px-32">
          {t('accentro:formTexts.areWeAllowedToContactYou')}
        </BodyText>
        <BodyText className="mt-px-32 lg:mt-px-48">
          {t('accentro:formTexts.newsletterBody')}
        </BodyText>
        <div className="mt-px-32 lg:mt-px-48">
          <FormProvider {...formProviderProps}>
            <form {...formProps}>
              <div className="grid grid-cols-12">
                <StyledEmailField>{EmailField}</StyledEmailField>
                <StyledLegalImprintField>
                  {LegalImprintField}
                </StyledLegalImprintField>
                <StyledSubmitButton>{SubmitButton}</StyledSubmitButton>
              </div>
            </form>
          </FormProvider>
          {SuccessDialog}
        </div>
        <div className="mt-px-32">
          <motion.span onHoverStart={onHoverStart}>
            <SimpleMuiButton
              onClick={onGoBackClick}
              startIcon={
                <AnimateIconTranslationLeft animate={controls}>
                  <ArrowLeft />
                </AnimateIconTranslationLeft>
              }
              variant="text"
              color="primary"
            >
              {t('accentro:formTexts.backToProperties')}
            </SimpleMuiButton>
          </motion.span>
        </div>
      </div>
    </PropertyIndexResultAreaInnerGrid>
  )
}
